import { useMediaQuery } from 'react-responsive';

export const useIsMobile = () => {
  return useMediaQuery({ maxWidth: 768 });
};

export const useIsDesktop = () => {
  return useMediaQuery({ minWidth: 769 });
};